import React, { useEffect, useState, useMemo } from "react";
import NetaqInput from "./NetaqInput";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "./TranslationText";
import Select from "react-select";
import { FetchCitiesthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";

const ShowsFilter = ({ onSubmit, currentFilters }) => {
  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const { citiesData } = useSelector((state) => state.ownerProfileSlice);
  const { translate } = useTranslate();
  const dispatch = useDispatch();

  const monthOptions = useMemo(() => [
    { text: translate("web.all", "All"), value: 0 },
    { text: translate("web.January", "January"), value: 1 },
    { text: translate("web.February", "February"), value: 2 },
    { text: translate("web.March", "March"), value: 3 },
    { text: translate("web.April", "April"), value: 4 },
    { text: translate("web.May", "May"), value: 5 },
    { text: translate("web.June", "June"), value: 6 },
    { text: translate("web.July", "July"), value: 7 },
    { text: translate("web.August", "August"), value: 8 },
    { text: translate("web.September", "September"), value: 9 },
    { text: translate("web.October", "October"), value: 10 },
    { text: translate("web.November", "November"), value: 11 },
    { text: translate("web.December", "December"), value: 12 },
  ], [translate]);

  const filterReset = () => {
    return {
      search: "",
      year: "",
      month: 0,
      country: null,
      countryDrop: {
        label: translate("web.chooseEmirate", "Choose Emirate"),
        value: null,
      },
      monthDrop: {
        label: translate("web.month", "Month"),
        text: translate("web.month", "Month"),
        value: 0,
      },
      showStatus: [],
    };
  };

  const [filterState, setFilterState] = useState(filterReset);

  useEffect(() => {
    dispatch(FetchCitiesthunk());
  }, [dispatch]);

  useEffect(() => {
    if (currentFilters) {
      let matchedCity = null;
      if (currentFilters.country && citiesData && citiesData.length > 0) {
        const city = citiesData.find((c) => String(c.id) === String(currentFilters.country));
        if (city) {
          matchedCity = {
            label: currentLanguage === "en" ? city.name : city.nameAr,
            value: city.id,
          };
        }
      }

      let matchedMonth = null;
      if (currentFilters.month !== undefined && currentFilters.month !== null && currentFilters.month !== "") {
        const found = monthOptions.find((m) => Number(m.value) === Number(currentFilters.month));
        if (found) {
          matchedMonth = {
            label: found.text,
            text: found.text,
            value: found.value,
          };
        }
      }

      setFilterState({
        search: currentFilters.search ?? "",
        year: currentFilters.year ?? "",
        month: currentFilters.month ?? 0,
        country: currentFilters.country ?? null,
        countryDrop: matchedCity || {
          label: currentLanguage === "en" ? "Choose Emirate" : "اختر الإمارة",
          value: null,
        },
        monthDrop: matchedMonth || {
          label: translate("web.month", "Month"),
          text: translate("web.month", "Month"),
          value: 0,
        },
        showStatus: currentFilters.showStatus ?? [],
      });
    }
  }, [currentFilters, citiesData, currentLanguage, monthOptions, translate]);

  const handleReset = () => {
    const resetState = filterReset();
    setFilterState(resetState);
    onSubmit(resetState);
  };

  const handleChange = (event, input) => {
    if (input === "country") {
      setFilterState((prev) => ({
        ...prev,
        country: event?.value ?? null,
        countryDrop: event,
      }));
    } else if (input === "month") {
      setFilterState((prev) => ({
        ...prev,
        month: event?.value ?? 0,
        monthDrop: event,
        showStatus: ["All"],
      }));
    } else if (input === "showStatus") {
      if (!event.target.checked) {
        setFilterState((prev) => ({
          ...prev,
          showStatus: prev.showStatus.filter((item) => item !== event.target.value),
        }));
      } else {
        setFilterState((prev) => ({
          ...prev,
          showStatus: prev.showStatus.concat(event.target.value),
        }));
      }
    } else if (event.target.name === "year") {
      setFilterState((prev) => ({
        ...prev,
        [event.target.name]: event.target.value,
        showStatus: ["All"],
      }));
    } else {
      setFilterState((prev) => ({
        ...prev,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState);
  };

  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          label={translate("web.showTitle", "Show Title")}
          name={"search"}
          placeholder={translate("web.showTitle", "Show Title")}
          type={"text"}
          value={filterState.search || ""}
          onChange={handleChange}
        />
      </div>

      <div className="mb-form-group">
        <label>
          {translate("web.showLocation", "Show Location")}
        </label>
        <Select
          options={[
            {
              label:
                currentLanguage === "en" ? "Choose Emirate" : "اختر الإمارة",
              value: null,
            },
            ...(citiesData
              ? citiesData.map((a) => ({
                  label: currentLanguage === "en" ? a.name : a.nameAr,
                  value: a.id,
                }))
              : []),
          ]}
          value={filterState.countryDrop}
          onChange={(e) => handleChange(e, "country")}
          placeholder={translate("web.chooseEmirate", "Choose Emirate")}
          name={"country"}
          isSearchable
          noOptionsMessage={() => translate("web.noOptions", "No Options")}
        />
      </div>

      <div className="mb-form-group">
        <NetaqInput
          className="form-control"
          name="year"
          type="number"
          min="1900"
          label={translate("web.year", "Year")}
          max="3000"
          step="1"
          value={filterState.year || ""}
          onChange={handleChange}
          disabled={false}
        />
      </div>

      <div className="mb-form-group-last">
        <NetaqInput
          type={"select"}
          listSelect={monthOptions}
          value={filterState.monthDrop}
          name={"month"}
          placeholder={translate("web.month", "Month")}
          label={translate("web.month", "Month")}
          onChange={(e) => handleChange(e, "month")}
          disabled={false}
        />
      </div>

      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"
            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          />
        </div>
      </div>
    </form>
  );
};

export default ShowsFilter;
